import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { IUser } from '../../interfaces/user.interface';
import { NotificationsPanelComponent } from './notifications-panel/notifications-panel.component';
import { OrganizationSwitcherComponent } from './organization-switcher/organization-switcher.component';
import { SearchMainEntitiesComponent } from './search-main-entities/search-main-entities.component';
import { UserAppsPanelComponent } from './user-apps-panel/user-apps-panel.component';
import { UserPanelComponent } from './user-panel/user-panel.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        OrganizationSwitcherComponent,
        UserAppsPanelComponent,
        NotificationsPanelComponent,
        UserPanelComponent,
        SearchMainEntitiesComponent
    ]
})
export class HeaderComponent {
    user = input<IUser | undefined>();
    currentUrl = input<string>();

    isReportsUrl = computed(() => this.currentUrl()?.startsWith('/reports'));
}
